// extracted by css-extract-rspack-plugin
export default {"host":"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__host-KZ4wnm","title":"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__title-BBXFZx","svg":"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__svg-VMvHcF"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"host\":\"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__host-KZ4wnm\",\"title\":\"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__title-BBXFZx\",\"svg\":\"src-domain-components-configuration-tab-empty-configuration-EmptyConfiguration-module__svg-VMvHcF\"}";
        // 1793705033143
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  